<template>
  <div>
    <v-row color="deep-purple accent-3" class="mb-4" v-if="editable">
      <v-toolbar :color="this.$pgsHelper.uiConfig().mainColor" dark>
        <v-text-field
          v-model="roomData.Nombre"
          hide-details
          single-line
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn @click="saveArea()" color="success">
          Guardar
        </v-btn>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col v-if="editable" md="2" cols="12">
        <v-form ref="form" lazy-validation>
          <v-select
            v-model="typeObj"
            :items="itemsObj"
            label="Objeto"
            outlined
          ></v-select>
          <v-text-field v-model="nombre" label="Nombre" required></v-text-field>

          <v-checkbox
            v-model="useCuenta"
            label="Permite Cuenta"
            required
          ></v-checkbox>

          <v-btn @click="addItem()" color="success" class="mr-4">
            Crear
          </v-btn>
        </v-form>
         <v-btn style="    bottom: 0;
    position: absolute;" @click="deleteArea()" color="red" dark>
          Eliminar Mapa
        </v-btn>
      </v-col>
      <v-col
        v-bind:class="[editable ? 'col-md-10 cols-10' : 'col-md-12 cols-12']"
        cols="2"
        style="overflow-x: auto;"
      >
        <v-row v-if="editable">
          <v-col md="2">
            <v-text-field
              v-model="wArea"
              @change="changeCanvasSize()"
              label="Ancho de area (Metros)"
            ></v-text-field>
          </v-col>
          <v-col md="2">
            <v-text-field
              v-model="hArea"
              @change="changeCanvasSize()"
              label="Alto de area (Metros)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn text @click="removeSelected()" color="red" dark>
              Eliminar Objeto
            </v-btn>
          </v-col>
        </v-row>

        <img
          v-show="false"
          ref="imgCar"
          width="100px"
          src="../../assets/img/golfCar.png"
        />
        <canvas
          ref="canvas"
          width="1200"
          height="300"
          style="border: 1px solid black;"
        ></canvas>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { fabric } from "fabric";
export default {
  name: "floorRestaurant",
  components: {},
  props: ["editable", "roomData"],
  data() {
    return {
      itemsObj: [
        { value: "table", text: "Mesa" },
        { value: "roundTable", text: "Mesa Circular" },
        { value: "bar", text: "Bar" },
        { value: "chair", text: "Silla" },
        { value: "golfCar", text: "Carro Golf" },
      ],
      deleted:[],
      hArea: 8,
      wArea: 8,
      nombre: "",
      useCuenta: true,
      typeObj: "table",
      grid: 30,
      backgroundColor: "#f8f8f8",
      lineStroke: "#ebebeb",
      tableFill: "rgba(150, 111, 51, 0.7)",
      tableStroke: "#694d23",
      tableShadow: "rgba(0, 0, 0, 0.4) 3px 3px 7px",
      chairFill: "rgba(67, 42, 4, 0.7)",
      chairStroke: "#32230b",
      chairShadow: "rgba(0, 0, 0, 0.4) 3px 3px 7px",
      barFill: "rgba(0, 93, 127, 0.7)",
      barStroke: "#003e54",
      barShadow: "rgba(0, 0, 0, 0.4) 3px 3px 7px",
      barText: "Bar",
      carFill: "rgba(255, 255, 255, 0.7)",
      wallFill: "rgba(136, 136, 136, 0.7)",
      wallStroke: "#686868",
      wallShadow: "rgba(0, 0, 0, 0.4) 5px 5px 20px",
      canvas: "",
      auxiliarData:{
        h:0,
        w:0,
        r:0,
      },
      fromData: [
        {
          type: "table",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 90,
          top: 59,
          width: 62,
          height: 92,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Mesa 1",
          id: "PWYCHtOfALUHhn2zioevocILL53diXX2",
          useCuenta: true,
          objects: [
            {
              type: "rect",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 60,
              height: 90,
              fill: "rgba(150, 111, 51, 0.7)",
              stroke: "#694d23",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              rx: 0,
              ry: 0,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 41.38,
              height: 15.82,
              fill: "#fff",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Mesa 1",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
          ],
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 45,
          top: 61,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 1",
          id: "O8RUkaP2iDHTEgkmgyv9i8vho9uEs34Y",
          useCuenta: true,
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 47,
          top: 114,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 1",
          id: "Pdj9DKK3HC2HunTrNQunZNZBrHaUBK3M",
          useCuenta: true,
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 161,
          top: 61,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 1",
          id: "Trd5obiIBI6ljFJ6XhUAt027t7gBMBBR",
          useCuenta: true,
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 163,
          top: 112,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 1",
          id: "PtL162oLve5SlJdVlSHNcGEklkVmlW7m",
          useCuenta: true,
        },
        {
          type: "table",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 272,
          top: 58,
          width: 62,
          height: 92,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Mesa 2",
          id: "OGlkLhx6CoPneq4SKREAtNcFdNj3BCUY",
          useCuenta: true,
          objects: [
            {
              type: "rect",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 60,
              height: 90,
              fill: "rgba(150, 111, 51, 0.7)",
              stroke: "#694d23",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              rx: 0,
              ry: 0,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 41.38,
              height: 15.82,
              fill: "#fff",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Mesa 2",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
          ],
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 349,
          top: 90,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 2",
          id: "WFozOrlEbNry0hi9tfkWkFJeV2Wmbxos",
          useCuenta: true,
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 231,
          top: 90,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 2",
          id: "yOjfZLNY57Mgooq6EGObrGoOKsCy2rX7",
          useCuenta: true,
        },
        {
          type: "table",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 807,
          top: 58,
          width: 62,
          height: 92,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Privada 3",
          id: "NzayPClmp9zXiAmAtAoQ0XcEcGSywJqE",
          useCuenta: true,
          objects: [
            {
              type: "rect",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 60,
              height: 90,
              fill: "rgba(150, 111, 51, 0.7)",
              stroke: "#694d23",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              rx: 0,
              ry: 0,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 52.47,
              height: 15.82,
              fill: "#fff",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Privada 3",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
          ],
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 877,
          top: 88,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Privada 3",
          id: "KNhOUHVK9ueE8zXWiPsXcPHlMIm6vbB8",
          useCuenta: true,
        },
        {
          type: "roundTable",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 452,
          top: 74,
          width: 62,
          height: 62,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Mesa 3",
          id: "mkcLb499riHRKBbY1Ay3Y2YmbukiPS4Z",
          useCuenta: true,
          objects: [
            {
              type: "circle",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 60,
              height: 60,
              fill: "rgba(150, 111, 51, 0.7)",
              stroke: "#694d23",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              radius: 30,
              startAngle: 0,
              endAngle: 6.283185307179586,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 41.38,
              height: 15.82,
              fill: "#fff",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Mesa 3",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
          ],
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 468,
          top: 38,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 3",
          id: "z4IlfC2QHCAJ0sm8dPeFbdPRi4nRKYEF",
          useCuenta: true,
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 468,
          top: 140,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 3",
          id: "FoBWJAmdgK8KG0qSPNnU7HbIHDffO99t",
          useCuenta: true,
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 521,
          top: 91,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 3",
          id: "zAPAT5emApj3xEryuKSTMEUDQFl2gPrs",
          useCuenta: true,
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 415,
          top: 90,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 3",
          id: "M1bsi2nuxG8E1BtD0ImmdeBPKVzvyDwq",
          useCuenta: true,
        },
        {
          type: "bar",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 63,
          top: 306,
          width: 182,
          height: 62,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1.34,
          scaleY: 1.05,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Barra Principal",
          id: "HqFQHx1Spdlki03njeSHvOhIZS4CDuRt",
          useCuenta: true,
          objects: [
            {
              type: "bar",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 180,
              height: 60,
              fill: "rgba(0, 93, 127, 0.7)",
              stroke: "#003e54",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              rx: 0,
              ry: 0,
              id: 0.6279619026098371,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 82.76,
              height: 15.82,
              fill: "#fff",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Barra Principal",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
          ],
        },
        {
          type: "bar",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 360,
          top: 306,
          width: 182,
          height: 62,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Barra de dulces",
          id: "FjqNwZEyhpCmL8z3EPHU5UfClWkWhBgN",
          useCuenta: true,
          objects: [
            {
              type: "bar",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 180,
              height: 60,
              fill: "rgba(0, 93, 127, 0.7)",
              stroke: "#003e54",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              rx: 0,
              ry: 0,
              id: 0.7854024742257626,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 87.44,
              height: 15.82,
              fill: "#fff",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Barra de dulces",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
          ],
        },
        {
          type: "table",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 807,
          top: 226,
          width: 62,
          height: 92,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Mesa 4",
          id: "zjiKWfdxMRephPv51WnApR1PWoQs6Epx",
          useCuenta: true,
          objects: [
            {
              type: "rect",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 60,
              height: 90,
              fill: "rgba(150, 111, 51, 0.7)",
              stroke: "#694d23",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              rx: 0,
              ry: 0,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "center",
              left: 0,
              top: 0,
              width: 41.38,
              height: 15.82,
              fill: "#fff",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Mesa 4",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
          ],
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 763,
          top: 228,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "Mesa 4",
          id: "gJ9p7ypnHfzVKKuPycsfri6cXbdvL0Lc",
          useCuenta: true,
        },
        {
          type: "chair",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 72,
          top: 263,
          width: 30,
          height: 30,
          fill: "rgba(67, 42, 4, 0.7)",
          stroke: "#32230b",
          strokeWidth: 2,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: {
            color: "rgba(0, 0, 0, 0.4)",
            blur: 7,
            offsetX: 3,
            offsetY: 3,
            affectStroke: false,
            nonScaling: false,
          },
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          Nombre: "",
          id: "uvBW9DxTkRfMbukE2uWhLh8CoGYIprdx",
          useCuenta: true,
        },
        {
          type: "golfCar",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 77,
          top: 423,
          width: 86.4,
          height: 112,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Carrito 1",
          id: "VRVNsqignCCAQkATDokZld8oCX9X7ZdT",
          useCuenta: true,
          objects: [
            {
              type: "rect",
              version: "4.4.0",
              originX: "center",
              originY: "top",
              left: 0,
              top: -56,
              width: 80,
              height: 110,
              fill: "rgba(255, 255, 255, 0.7)",
              stroke: "#694d23",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              rx: 0,
              ry: 0,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "top",
              left: 0,
              top: -51,
              width: 49.34,
              height: 15.82,
              fill: "#000",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Carrito 1",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
            {
              type: "image",
              version: "4.4.0",
              originX: "center",
              originY: "top",
              left: 0,
              top: -6,
              width: 432,
              height: 288,
              fill: "rgb(0,0,0)",
              stroke: null,
              strokeWidth: 0,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 0.2,
              scaleY: 0.2,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              cropX: 0,
              cropY: 0,
              src: "http://localhost:8080/img/golfCar.1c1d2574.png",
              crossOrigin: null,
              filters: [],
            },
          ],
        },
        {
          type: "golfCar",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 206,
          top: 422,
          width: 86.4,
          height: 112,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Carrito 2",
          id: "ePt9BSBH6nNhPgbxgkQ0PXXJuu4NNhUy",
          useCuenta: true,
          objects: [
            {
              type: "rect",
              version: "4.4.0",
              originX: "center",
              originY: "top",
              left: 0,
              top: -56,
              width: 80,
              height: 110,
              fill: "rgba(255, 255, 255, 0.7)",
              stroke: "#694d23",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              rx: 0,
              ry: 0,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "top",
              left: 0,
              top: -51,
              width: 49.34,
              height: 15.82,
              fill: "#000",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Carrito 2",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
            {
              type: "image",
              version: "4.4.0",
              originX: "center",
              originY: "top",
              left: 0,
              top: -6,
              width: 432,
              height: 288,
              fill: "rgb(0,0,0)",
              stroke: null,
              strokeWidth: 0,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 0.2,
              scaleY: 0.2,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              cropX: 0,
              cropY: 0,
              src: "http://localhost:8080/img/golfCar.1c1d2574.png",
              crossOrigin: null,
              filters: [],
            },
          ],
        },
        {
          type: "golfCar",
          version: "4.4.0",
          originX: "left",
          originY: "top",
          left: 326,
          top: 422,
          width: 86.4,
          height: 112,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 0,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          Nombre: "Carrito 3",
          id: "QJ7kWkHSyiauNEpoFYVBxDV2zd12HicM",
          useCuenta: true,
          objects: [
            {
              type: "rect",
              version: "4.4.0",
              originX: "center",
              originY: "top",
              left: 0,
              top: -56,
              width: 80,
              height: 110,
              fill: "rgba(255, 255, 255, 0.7)",
              stroke: "#694d23",
              strokeWidth: 2,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: {
                color: "rgba(0, 0, 0, 0.4)",
                blur: 7,
                offsetX: 3,
                offsetY: 3,
                affectStroke: false,
                nonScaling: false,
              },
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              rx: 0,
              ry: 0,
            },
            {
              type: "i-text",
              version: "4.4.0",
              originX: "center",
              originY: "top",
              left: 0,
              top: -51,
              width: 49.34,
              height: 15.82,
              fill: "#000",
              stroke: null,
              strokeWidth: 1,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 1,
              scaleY: 1,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              text: "Carrito 3",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Calibri",
              fontStyle: "normal",
              lineHeight: 1.16,
              underline: false,
              overline: false,
              linethrough: false,
              textAlign: "center",
              textBackgroundColor: "",
              charSpacing: 0,
              path: null,
              styles: {},
            },
            {
              type: "image",
              version: "4.4.0",
              originX: "center",
              originY: "top",
              left: 0,
              top: -6,
              width: 432,
              height: 288,
              fill: "rgb(0,0,0)",
              stroke: null,
              strokeWidth: 0,
              strokeDashArray: null,
              strokeLineCap: "butt",
              strokeDashOffset: 0,
              strokeLineJoin: "miter",
              strokeUniform: false,
              strokeMiterLimit: 4,
              scaleX: 0.2,
              scaleY: 0.2,
              angle: 0,
              flipX: false,
              flipY: false,
              opacity: 1,
              shadow: null,
              visible: true,
              backgroundColor: "",
              fillRule: "nonzero",
              paintFirst: "fill",
              globalCompositeOperation: "source-over",
              skewX: 0,
              skewY: 0,
              cropX: 0,
              cropY: 0,
              src: "http://localhost:8080/img/golfCar.1c1d2574.png",
              crossOrigin: null,
              filters: [],
            },
          ],
        },
      ],
    };
  },
  computed: {},
  methods: {
    async addItem() {
      if (this.typeObj == "table") {
        this.addRect(0, 0, 60, 90, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: await  this.generate_firebase_token(),
          object:{scaleX:1,scaleY:1},
        });
      } else if (this.typeObj == "roundTable") {
        this.addCircle(0, 0, 30, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: await  this.generate_firebase_token(),
          object:{scaleX:1,scaleY:1},
        });
      } else if (this.typeObj == "bar") {
        this.addBar(0, 0, 180, 60, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: await this.generate_firebase_token(),
          object:{scaleX:1,scaleY:1},
        });
      } else if (this.typeObj == "chair") {
        this.addChair(0, 0, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: await this.generate_firebase_token(),
          object:{scaleX:1,scaleY:1},
        });
      } else if (this.typeObj == "golfCar") {
        this.addGolfCar(0, 0, 80, 110, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: await this.generate_firebase_token(),
          object:{scaleX:1,scaleY:1},
        });
      }
      this.nombre = null;
      this.useCuenta = true;
    },
    sendLinesToBack() {
      this.canvas.getObjects().map((o) => {
        if (o.type === "line") {
          this.canvas.sendToBack(o);
        }
      });
    },
    addRect(left, top, width, height, params) {
      const id = Math.random();
      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: this.tableFill,
        stroke: this.tableStroke,
        strokeWidth: 2,
        shadow: this.tableShadow,
        originX: "center",
        originY: "center",
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
      });
      const t = new fabric.IText(params.Nombre, {
        fontFamily: "Calibri",
        fontSize: 14,
        fill: "#fff",
        lockUniScaling: true,
        textAlign: "center",
        originX: "center",
        originY: "center",
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: "table",
        scaleX:params?.object?.scaleX,
        scaleY:params?.object?.scaleY,
        angle: params.angle ? params.angle : 0,
        Nombre: params.Nombre,
        useCuenta: params.useCuenta,
        id: params.id,
        number: id,
      });
      if (params.useCuenta) {
        g.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            
            this.$router.push({ path: "/sales-point" });
          }
        });
      }

      this.canvas.add(g);
    },
    addGolfCar(left, top, width, height, params) {
      const id = Math.random();
      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: this.carFill,
        stroke: this.tableStroke,
        strokeWidth: 2,
        shadow: this.tableShadow,
        originX: "center",

        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
      });
      const t = new fabric.IText(params.Nombre, {
        top: 5,
        fontFamily: "Calibri",
        fontSize: 14,
        fill: "#000",
        textAlign: "center",
        originX: "center",
      });

      const imageCar = new fabric.Image(this.$refs.imgCar, {
        top: 50,
        scaleX: 1 / 5,
        scaleY: 1 / 5,
        originX: "center",
      });

      const g = new fabric.Group([o, t, imageCar], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: "golfCar",
        scaleX:params?.object?.scaleX,
        scaleY:params?.object?.scaleY,
        Nombre: params.Nombre,
        angle: params.angle ? params.angle : 0,
        useCuenta: params.useCuenta,
        id: params.id,
        number: id,
      });
      if (params.useCuenta) {
        g.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            
            this.$router.push({ path: "/sales-point" });
          }
        });
      }

      this.canvas.add(g);
      this.canvas.renderAll();
    },
    addChair(left, top, params) {
      const id = Math.random();

      const o = new fabric.Rect({
        left: left,
        top: top,
        width: 30,
        height: 30,
        fill: this.chairFill,
        stroke: this.chairStroke,
        strokeWidth: 2,
        shadow: this.chairShadow,
        originX: "left",
        originY: "top",
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        scaleX:params?.object?.scaleX,
        scaleY:params?.object?.scaleY,
        type: "chair",
        Nombre: params.Nombre,
        useCuenta: params.useCuenta,
        id: params.id,
        angle: params.angle ? params.angle : 0,
        number: id,
      });

      if (params.useCuenta) {
        o.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            
            this.$router.push({ path: "/sales-point" });
          }
        });
      }

      this.canvas.add(o);
    },
    addCircle(left, top, radius, params) {
      const id = Math.random();
      const o = new fabric.Circle({
        radius: radius,
        fill: this.tableFill,
        stroke: this.tableStroke,
        strokeWidth: 2,
        shadow: this.tableShadow,
        originX: "center",
        originY: "center",
        centeredRotation: true,
      });
      const t = new fabric.IText(params.Nombre, {
        fontFamily: "Calibri",
        fontSize: 14,
        fill: "#fff",
        textAlign: "center",
        originX: "center",
        originY: "center",
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        scaleX:params?.object?.scaleX,
        scaleY:params?.object?.scaleY,
        Nombre: params.Nombre,
        useCuenta: params.useCuenta,
        angle: params.angle ? params.angle : 0,
        id: params.id,
        type: "roundTable",
        number: id,
      });

      if (params.useCuenta) {
        g.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            
            this.$router.push({ path: "/sales-point" });
          }
        });
      }
      this.canvas.add(g);
      return g;
    },
    addBar(left, top, width, height, params) {
      const id = Math.random();
      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: this.barFill,
        stroke: this.barStroke,
        strokeWidth: 2,
        shadow: this.barShadow,
        originX: "center",
        originY: "center",
        type: "bar",
        id: id,
      });
      const t = new fabric.IText(params.Nombre, {
        fontFamily: "Calibri",
        fontSize: 14,
        fill: "#fff",
        textAlign: "center",
        originX: "center",
        originY: "center",
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        Nombre: params.Nombre,
        scaleX:params?.object?.scaleX,
        scaleY:params?.object?.scaleY,
        angle: params.angle ? params.angle : 0,
        useCuenta: params.useCuenta,
        id: params.id,
        type: "bar",
      });
      if (params.useCuenta) {
        g.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            
            this.$router.push({ path: "/sales-point" });
          }
        });
      }
      this.canvas.add(g);
      return g;
    },
    deleteObject(eventData, transform) {
      this.$swal({
        title: "¿Deseas eliminar este elemento?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          var target = transform.target;
          
          var canvas = target.canvas;
          this.deleted.push({useCuenta:target.useCuenta,id:target.id});
          canvas.remove(target);
          canvas.requestRenderAll();
        }
      });
    },
    renderIcon(ctx, left, top, styleOverride, fabricObject) {
      let deleteIcon =
        "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";

      var img = document.createElement("img");
      img.src = deleteIcon;
      var size = 20;
      ctx.save();
      ctx.translate(left, top);
      ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
      ctx.drawImage(img, -size / 2, -size / 2, size, size);
      ctx.restore();
    },
    removeSelected() {
      const o = this.canvas.getActiveObject();
      if (o) {
        this.$swal({
          title: "¿Deseas eliminar este elemento?",
          text: "",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Eliminar",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.deleted.push({useCuenta:o.useCuenta,id:o.id});
            this.canvas.remove(o);
            this.canvas.discardActiveObject();
            this.canvas.renderAll();
          }
        });
      }
    },
    blockCanvas() {
      this.canvas.getObjects().map((o) => {
        o.hasControls = false;
        o.lockMovementX = true;
        o.lockMovementY = true;
      });
      this.canvas.selection = false;
      this.canvas.hoverCursor = "pointer";
      this.canvas.discardActiveObject();
      this.canvas.renderAll();
    },
    canvasToJson() {
      let data = this.canvas.toJSON(["Nombre", "id", "useCuenta"]);
      
      let objects = [];
      data.objects.forEach((obj) => {
        if (obj.type != "line") {
          objects.push(obj);
        }
      });
      return objects;
    },
    jsonToCanvas() {
      this.fromData.forEach((element) => {
        if (element.type == "table") {
          this.addRect(
            element.left,
            element.top,
            (element.width),
            (element.height),
            {
              Nombre: element.Nombre,
              useCuenta: element.useCuenta,
              id: element.id,
              angle: element.angle,
              object:element
            }
          );
        } else if (element.type == "chair") {
          this.addChair(element.left, element.top, {
            Nombre: element.Nombre,
            useCuenta: element.useCuenta,
            id: element.id,
            angle: element.angle,
            object:element
          });
        } else if (element.type == "roundTable") {
          this.addCircle(element.left, element.top, 30, {
            Nombre: element.Nombre,
            useCuenta: element.useCuenta,
            id: element.id,
            angle: element.angle,
            object:element
          });
        } else if (element.type == "bar") {
          
          this.addBar(
            element.left,
            element.top,
            element.width,
            element.height,
            {
              Nombre: element.Nombre,
              useCuenta: element.useCuenta,
              id: element.id,
              angle: element.angle,
              object:element
            }
          );
        } else if (element.type == "golfCar") {
          this.addGolfCar(
            element.left,
            element.top,
            element.width,
            element.height,
            {
              Nombre: element.Nombre,
              useCuenta: element.useCuenta,
              id: element.id,
              angle: element.angle,
              object:element
            }
          );
        }
      });
    },
    generate_token(length) {
      var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split(
        ""
      );
      var b = [];
      for (var i = 0; i < length; i++) {
        var j = (Math.random() * (a.length - 1)).toFixed(0);
        b[i] = a[j];
      }
      let token = b.join("");
      let existToken = this.$pgsHelper.getById(this.canvasToJson(), "id", token);
      if (existToken) {
        token = this.generate_token();
      }
      return token;
    },
    async generate_firebase_token(){
        let id         = await this.$store.getters.getFirebaseApp.database.getNewKey("AYB/Contenedores");
        
        return id;
    },
    changeCanvasSize() {
      this.canvas.setHeight(this.hArea*100);
      this.canvas.setWidth(this.wArea*100);
      this.renderGrid();
    },
    deleteArea() {
      this.$emit("deleteArea", this.roomData);
    },
    saveArea() {
      this.roomData.Mapa = (this.roomData.Mapa)?this.roomData.Mapa:{};
      this.roomData.Mapa.Alto   = parseInt(this.hArea);
      this.roomData.Mapa.Ancho  = parseInt(this.wArea);
      this.roomData.Mapa.Mapa   = this.canvasToJson();
      this.roomData.Mapa.Area   = this.roomData.Id;
      this.roomData.Deleted     = this.deleted;
      this.$emit("updateArea", this.roomData);
    },
    renderGrid(){
      for (let i = 0; i < this.canvas.height / this.grid; i++) {
        const lineX = new fabric.Line(
          [0, i * this.grid, this.canvas.width, i * this.grid],
          {
            stroke: this.lineStroke,
            selectable: false,
            type: "line",
          }
        );

        this.sendLinesToBack();
        this.canvas.add(lineX);
      }

      for (let i = 0; i < this.canvas.width / this.grid; i++) {
        const lineY = new fabric.Line(
          [i * this.grid, 0, i * this.grid, this.canvas.height],
          {
            stroke: this.lineStroke,
            selectable: false,
            type: "line",
          }
        );
        this.sendLinesToBack();

        this.canvas.add(lineY);
      }
    }
  },
  beforeMount: function() {},
  mounted: function() {
    this.fromData = (this.roomData.Mapa)?this.roomData.Mapa.Mapa:[];
    this.wArea    = (this.roomData.Mapa)?this.roomData.Mapa.Ancho:8;
    this.hArea    = (this.roomData.Mapa)?this.roomData.Mapa.Alto:8;
    let ref       = this.$refs;
    /*let width = (window.innerWidth > 0) ? window.innerWidth  : screen.width;
    let height = (window.innerHeight > 0) ? window.innerHeight : screen.height; */

    this.canvas = new fabric.Canvas(this.$refs.canvas, {
      width: this.wArea * 100,
      height: this.hArea * 100,
    });

    this.canvas.on('object:scaling', (e)=>{
      let obj = e.target;
      this.auxiliarData.w = obj.width * obj.scaleX;
      this.auxiliarData.h = obj.height * obj.scaleY;
      this.auxiliarData.r = obj.radius * obj.scalex;
      
    });

    this.canvas.on('object:modified', (e) => {
      if (e.target) {
        let group = e.target
        
        if(group.type != "roundTable" && group.type != "golfCar" ){
          if(group._objects){
          
          if(group._objects.length >= 2){
            let rect = group._objects[0]
            if(this.auxiliarData.h == 0 || this.auxiliarData.w == 0){
              this.auxiliarData.w = rect.width;
              this.auxiliarData.h = rect.height;
            }
            
              rect.set({height:this.auxiliarData.h, width: this.auxiliarData.w})
           
            
            let text = group._objects[1]
            this.canvas.remove(group)
            this.canvas.add(new fabric.Group([rect,text], {
              top: group.top,
              left: group.left,
              type: group.type,
              angle: group.angle,
              Nombre: group.Nombre,
              useCuenta: group.useCuenta,
              id: group.id,
              number: group.id,
            }))
            
          }
        }
        }
        
        this.auxiliarData.w = 0;
        this.auxiliarData.h = 0;
        this.auxiliarData.r = 0;
      }
    });

    fabric.Object.prototype.controls.deleteControl = new fabric.Control({
      x: 0.5,
      y: -0.5,
      offsetY: 16,
      cursorStyle: "pointer",
      mouseUpHandler: this.deleteObject,
      render: this.renderIcon,
      cornerSize: 24,
    });
    if (this.editable) {
      this.renderGrid();
    }
    this.canvas.selection = false;
    //this.addRect(40, 40, 60, 90,"Mesa 1");
    setTimeout(() => {
      this.jsonToCanvas();
    }, 2000);

    if (!this.editable) {
      setTimeout(() => {
        this.blockCanvas();
      }, 2000);
    }
  },
};
</script>
